import React from 'react';
import { PRODUCTS, INDUSTRIES } from '../data/constants';
import { scrollToSection } from '../utils/scrollTo';

const Footer: React.FC = () => (
  <footer className="footer-root">
    <div className="footer-inner">
      <div className="footer-grid">

        {/* Brand */}
        <div>
          <img
            src="/logo.png"
            alt="Gulf Fibertech Industries"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{ height: 100, width: 'auto', objectFit: 'contain', objectPosition: 'left center', cursor: 'pointer', filter: 'brightness(0) invert(1)' }}
          />
          <p className="footer-desc">
            Pioneers in high-quality GRP manufacturing across the Gulf. Committed to excellence, durability, and performance in demanding industrial environments.
          </p>
          {/* <div style={{ display: 'flex', gap: 8 }}>
            {['in', 'f', 'tw', 'yt'].map(s => (
              <div
                key={s}
                style={{ width: 34, height: 34, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 11, color: 'rgba(255,255,255,0.4)', fontWeight: 700, transition: 'all 0.2s' }}
                onMouseEnter={e => { const el = e.currentTarget as HTMLDivElement; el.style.background = '#f5c518'; el.style.color = '#1a2b4a'; el.style.borderColor = '#f5c518'; }}
                onMouseLeave={e => { const el = e.currentTarget as HTMLDivElement; el.style.background = 'rgba(255,255,255,0.06)'; el.style.color = 'rgba(255,255,255,0.4)'; el.style.borderColor = 'rgba(255,255,255,0.1)'; }}
              >
                {s}
              </div>
            ))}
          </div> */}
        </div>

        {/* Products */}
        <div>
          <div className="footer-col-head">Products</div>
          {PRODUCTS.slice(0, 6).map(p => (
            <a key={p.title} className="footer-link" href="#gallery" onClick={e => { e.preventDefault(); scrollToSection('gallery'); }}>{p.title}</a>
          ))}
        </div>

        {/* Industries */}
        <div>
          <div className="footer-col-head">Industries</div>
          {INDUSTRIES.map(i => (
            <a key={i.name} className="footer-link" href="#" onClick={e => e.preventDefault()}>{i.name}</a>
          ))}
        </div>

        {/* Company + Subscribe */}
        <div>
          <div className="footer-col-head">Company</div>
          {['About Us', 'Products', 'Why GRP', 'Contact Us'].map(l => (
            <a key={l} className="footer-link" href="#" onClick={e => {
              e.preventDefault();
              scrollToSection(l === 'About Us' ? 'about' : l === 'Products' ? 'gallery' : l === 'Why GRP' ? 'why-grp' : 'contact');
            }}>{l}</a>
          ))}
          {/* <div style={{ marginTop: 24 }}>
            <div className="footer-col-head">Subscribe to Our News</div>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', lineHeight: 1.6, marginBottom: 14 }}>
              Latest product launches and updates from Gulf Fibertech.
            </p>
            <div className="footer-email-wrap">
              <input type="email" placeholder="Your email address" className="footer-email-input" />
              <button className="footer-sub-btn">Subscribe</button>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <span className="footer-copy">
          © {new Date().getFullYear()} Gulf Fibertech Industries LLC. All Rights Reserved. | UAE Manufactured
        </span>
        {/* <div className="footer-legal">
          {['Privacy Policy', 'Terms of Use', 'Sitemap'].map(l => (
            <span key={l}
              onMouseEnter={e => ((e.currentTarget as HTMLSpanElement).style.color = '#f5c518')}
              onMouseLeave={e => ((e.currentTarget as HTMLSpanElement).style.color = 'rgba(255,255,255,0.28)')}
            >{l}</span>
          ))}
        </div> */}
      </div>
    </div>
  </footer>
);
export default Footer;
